/**
 * Utilidades para validación y formato de números de teléfono.
 */

/**
 * Obtiene solo los dígitos numéricos de un valor.
 * @param {string|number} telefono
 * @returns {string} Dígitos numéricos
 */
export const obtenerDigitosTelefono = (telefono) => {
  if (telefono === null || telefono === undefined) return "";
  return String(telefono).replace(/\D/g, "");
};

/**
 * Comprueba si un teléfono excede los 10 dígitos permitidos.
 * @param {string|number} telefono
 * @returns {boolean} true si tiene más de 10 dígitos
 */
export const tieneMasDe10Digitos = (telefono) => {
  return obtenerDigitosTelefono(telefono).length > 10;
};

/**
 * Mensaje estándar de error cuando un teléfono excede 10 dígitos.
 */
export const MENSAJE_ERROR_TELEFONO_MAX_DIGITOS =
  "El número de teléfono no puede tener más de 10 dígitos";

/**
 * Valida un teléfono y devuelve el mensaje de error o null si es válido.
 * @param {string|number} telefono
 * @param {string} [nombreCampo="El número de teléfono"]
 * @returns {string|null} Mensaje de error o null
 */
export const validarTelefonoMaxDigitos = (telefono, nombreCampo = "El número de teléfono") => {
  if (tieneMasDe10Digitos(telefono)) {
    return `${nombreCampo} no puede tener más de 10 dígitos`;
  }
  return null;
};
